import React, { useEffect, useState } from "react";
import { Table, Input, Tag, Space, Popconfirm, Select } from "antd";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import { ReactComponent as EditIcon } from "../../assets/edit-icon.svg";
import { ReactComponent as DeleteIcon } from "../../assets/delete-icon.svg";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "./redux/actions";
import SpinnerComponent from "../../components/spinner";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import CheckSvg from "../../assets/check.svg.png";
import CustomPagination from "../../components/customPagination/CustomPagination";
import AMultiSelect from "../../components/AMultiSelect";

const MaterialTemplatesTable = ({ canUpdate }) => {
  const [sortedInfo, setSortedInfo] = useState(null);
  const [dataSource, setDataSource] = useState([]);
  const [fetchLoading, setFetchLoading] = useState(false);
  const [currentDelRecord, setCurrentDelRecord] = useState({});
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = useState(() => 1);
  const [resultPerPage, setResultPerPage] = useState(() => 10);
  const [req, setReq] = useState(false);
  const [search, setSearch] = useState({});
  const [defaultPageOneReq, setDefaultPageOneReq] = useState(false);
  const [revisionCheckedList, setRevisionCheckedList] = useState([]);
  const [distributionCheckedList, setDistributionCheckedList] = useState([]);
  const [sectionSearch, setSectionSearch] = useState(null);
  const [secDropDownOpen, setSecDropDownOpen] = useState(false);
  const [revDropDownOpen, setRevDropDownOpen] = useState(false);
  const [disDropDownOpen, setDisDropDownOpen] = useState(false);
  const { Option } = Select;

  const StatusOptions = [
    {
      label: "Yes",
      value: true,
    },
    {
      label: "No",
      value: false,
    },
  ];
  const SectionOptions = [
    {
      label: "IMS",
      value: "ims",
    },
    {
      label: "Project",
      value: "project",
    },
  ];
  const {
    allTemplates = [],
    fetchTemplateLoading,
    deleteTemplateLoading,
    totalRecords,
    revisionControl,
    distributionControl,
  } = useSelector((state) => state.materialTemplatesReducer);

  useEffect(() => {
    if (allTemplates) {
      setDataSource(allTemplates);
      setFetchLoading(false);
    }
  }, [allTemplates]);

  const toTitleCase = (str) => {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  };

  useEffect(() => {
    if (page && resultPerPage && page > 0 && resultPerPage > 0) {
      setFetchLoading(true);
      dispatch(
        actions.fetchAllTemplates({
          page: page,
          per_page: resultPerPage,
          ...search,
          sort: sortedInfo?.order && sortedInfo?.columnKey,
          order: sortedInfo?.order
            ? sortedInfo?.order === "ascend"
              ? "asc"
              : "desc"
            : null,
        })
      );
    }
  }, [page, resultPerPage, search, sortedInfo]);

  useEffect(() => {
    // Initial fetch when component mounts
    if (!defaultPageOneReq) {
      setDefaultPageOneReq(true);
    }
  }, []);

  useEffect(() => {
    let paramsPage = 1;
    if (paramsPage && resultPerPage && paramsPage > 0 && resultPerPage > 0) {
      dispatch(
        actions.fetchAllTemplates({
          page: paramsPage,
          per_page: resultPerPage,
          ...search,
        })
      );
      setPage(1);
    }
  }, [defaultPageOneReq]);

  useEffect(() => {
    debouncedCallApi();
  }, [sortedInfo]);

  const [debouncedCallApi] = useState(() =>
    _.debounce(() => setReq((prev) => !prev), 1000)
  );

  const [debouncedDefaultPageOneCallApi] = useState(() =>
    _.debounce(() => setDefaultPageOneReq((prev) => !prev), 1000)
  );

  useEffect(() => {
    if (!deleteTemplateLoading) {
      dispatch(
        actions.fetchAllTemplates({
          page: page,
          per_page: resultPerPage,
          ...search,
          sort: sortedInfo?.order && sortedInfo?.columnKey,
          order: sortedInfo?.order
            ? sortedInfo?.order === "ascend"
              ? "asc"
              : "desc"
            : null,
        })
      );
    }
  }, [deleteTemplateLoading]);
  useEffect(() => {
    setDataSource(allTemplates);
  }, [allTemplates]);

  useEffect(() => {
    setFetchLoading(fetchTemplateLoading);
  }, [fetchTemplateLoading]);

  const handleChange = (pagination, filter, sorter) => {
    if (secDropDownOpen || revDropDownOpen || disDropDownOpen) {
      return;
    }
    setSortedInfo(sorter);
  };

  const handleDelete = (record) => {
    setCurrentDelRecord(record);
    dispatch(actions.deleteTemplate(record));
  };

  const searchInput = (key) => (
    <Input
      onClick={(e) => e.stopPropagation()}
      onChange={(e) => {
        setSearch({
          ...search,
          [key]: e.target.value,
        });
        debouncedDefaultPageOneCallApi();
      }}
    />
  );
  const handleSelectOnchange = (value, options, key, setHandler) => {
    if (value == undefined) {
      setHandler(null);
      handleMultiSelect("", key);
    } else {
      value = [value];
      if (value.includes("all")) {
        setHandler([...options.map((item) => item.value)]);
        value = options.map((item) => item.value);
      } else if (value.includes("not-all")) {
        setHandler([]);
        value = [];
      } else {
        setHandler(value);
      }
      handleMultiSelect(value, key);
    }
  };

  const handleSearchOnchange = (value, key, setHandler) => {
    if (value === undefined) {
      setHandler(null);
      handleMultiSelect("", key);
    } else {
      setHandler(value);
      handleMultiSelect(value, key);
    }
  };
  const handleMultiSelect = (list, key) => {
    setSearch({
      ...search,
      [key]: list,
    });
    debouncedCallApi();
  };
  const handleNavigate = (id) =>
    navigate(`/settings/material-templates/update-template/${id}`);

  const columns = [
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div projects">
            <div
              className="special-table-header-text projects-column"
              style={{ minHeight: "36px", height: "27px" }}
            >
              Projects
            </div>
            <div className="projects-search-input">{searchInput("project")}</div>
          </div>
        );
      },
      dataIndex: "project",
      key: "project",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "project" && sortedInfo?.order,
      ellipsis: true,
      width: "20%",
      render: (project, { id }) => (
        <div onClick={() => handleNavigate(id)}>{project || "N/A"}</div>
      ),
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div client">
            <div
              className="special-table-header-text"
              style={{ minHeight: "36px", height: "27px" }}
            >
              Client
            </div>
            <div className="client-search-input">{searchInput("client")}</div>
          </div>
        );
      },
      dataIndex: "client",
      key: "client",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "client" && sortedInfo?.order,
      ellipsis: true,
      width: "30%",
      render: (client, { id }) => (
        <div onClick={() => handleNavigate(id)}>{client || "N/A"}</div>
      ),
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div template-name">
            <div
              className="special-table-header-text"
              style={{ minHeight: "36px", height: "27px" }}
            >
              Template Name
            </div>
            <div className="template-name-search-input">{searchInput("name")}</div>
          </div>
        );
      },
      dataIndex: "name",
      key: "name",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "name" && sortedInfo?.order,
      ellipsis: true,
      width: "30%",
      render: (name, { id }) => (
        <div onClick={() => handleNavigate(id)}>{name}</div>
      ),
    },
    {
      title: null,
      dataIndex: "",
      key: "action",
      align: "center",
      render: (_, record) => {
        if (!canUpdate) {
          return;
        }

        return deleteTemplateLoading && record.id === currentDelRecord.id ? (
          <SpinnerComponent fontSize={14} />
        ) : (
          <Space size={15} align="baseline">
            <EditIcon
              width={18}
              height={18}
              className="custom-icon"
              onClick={() => {
                handleNavigate(record.id);
              }}
            />
            <Popconfirm
              title="Are you sure you want to delete this template?"
              placement="topRight"
              onConfirm={() => handleDelete(record)}
              okText="Yes"
              cancelText="No"
            >
              <DeleteIcon width={18} height={18} className="custom-icon" />
            </Popconfirm>
          </Space>
        );
      },
    }
  ];

  return (
    <>
      <div className="table-main-div-holder" style={{ borderTop: 'none' }}>
        <Table
          className="special-table doc-type-table"
          columns={columns}
          scroll={{ x: !fetchTemplateLoading }}
          onChange={handleChange}
          dataSource={dataSource}
          pagination={false}
          sortUpIcon={<UpOutlined />}
          sortDownIcon={<DownOutlined />}
          loading={fetchTemplateLoading}
          style={{ borderTop: 'none' }}
        />
      </div>
      <CustomPagination
        page={page}
        setPage={setPage}
        resultPerPage={resultPerPage}
        setResultPerPage={setResultPerPage}
        debouncedCallApi={debouncedCallApi}
        totalRecord={totalRecords}
      />
    </>
  );
};
export default MaterialTemplatesTable;
